import React, { useState } from 'react';

// Components
import { WpTab, WpTabs } from '..';
import { WpBadge } from 'Wpds/components/badge';

const TabsDocs = () => {
  const [activeTab, setActiveTab] = useState('one');
  return (
    <>
      <div className="d-flex flex-column">
        <WpTabs activeTab={activeTab} onTabClick={setActiveTab}>
          <WpTab tabId="one">Tab One</WpTab>
          <WpTab
            tabId="two"
            badge={
              <WpBadge color="purple" size="sm">
                New
              </WpBadge>
            }
          >
            Tab Two
          </WpTab>
          <WpTab tabId="three">Tab Three</WpTab>
        </WpTabs>
        {activeTab === 'one' && <div className="py-3">Tab One Contents</div>}
        {activeTab === 'two' && <div className="py-3">Tab Two Contents</div>}
        {activeTab === 'three' && <div className="py-3">Tab Three Contents</div>}
      </div>
    </>
  );
};

export default TabsDocs;
